var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
          "auto-fetch": false,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("dateText") } },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            clearable: false,
                            format: "dd/MM/yyyy",
                            "value-format": "yyyy-MM-dd",
                            placeholder: _vm.$t("dateText"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParamsTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime = $$v
                            },
                            expression: "queryParamsTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.Menu"),
                          prop: "menu",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "option-list": _vm.menuList },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.menu,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "menu", $$v)
                            },
                            expression: "queryParams.menu",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.queryParams.menu === "Invoice Review"
                  ? [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Invoice", prop: "invoiceId" } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                on: { change: _vm.handleQuery },
                                model: {
                                  value: _vm.queryParams.invoiceId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParams,
                                      "invoiceId",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "queryParams.invoiceId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "Transaction", prop: "transNo" },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                on: { change: _vm.handleQuery },
                                model: {
                                  value: _vm.queryParams.transNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParams,
                                      "transNo",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "queryParams.transNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("invoiceReview.client"),
                                prop: "clientCode",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { clearable: "" },
                                on: { change: _vm.handleQuery },
                                model: {
                                  value: _vm.queryParams.clientCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParams,
                                      "clientCode",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "queryParams.clientCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("invoiceReview.week"),
                                prop: "billingWeekStart",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  "value-format": "yyyy-MM-dd",
                                },
                                on: { change: _vm.handleQuery },
                                model: {
                                  value: _vm.queryParams.billingWeekStart,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryParams,
                                      "billingWeekStart",
                                      $$v
                                    )
                                  },
                                  expression: "queryParams.billingWeekStart",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.Method"),
                                prop: "action",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { clearable: "" },
                                  on: { change: _vm.handleQuery },
                                  model: {
                                    value: _vm.queryParams.action,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParams, "action", $$v)
                                    },
                                    expression: "queryParams.action",
                                  },
                                },
                                _vm._l(_vm.reviewActions, function (action) {
                                  return _c("el-option", {
                                    key: action,
                                    attrs: { label: action, value: action },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.dialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.dialogVisible,
                width: "800px",
                "before-close": _vm.handleCancel,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [_c("operation-log-detail", { attrs: { content: _vm.jsonData } })],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }